const data = [
  {
    id: 0,
    imageEllipse: require('../images/onBoardingSlideshow/1_ellipse.webp'),
    image1: require('../images/onBoardingSlideshow/1_1.webp'),
    image2: require('../images/onBoardingSlideshow/1_2.webp'),
    image3: require('../images/onBoardingSlideshow/1_3.webp'),
    headline: 'Diabetes Management',
    subtitle:
      'Diabetes management, personalized coaching, health metrics and more.',
  },
  {
    id: 1,
    imageEllipse: require('../images/onBoardingSlideshow/2_ellipse.webp'),
    image1: require('../images/onBoardingSlideshow/2_1.webp'),
    image2: require('../images/onBoardingSlideshow/2_2.webp'),
    image3: require('../images/onBoardingSlideshow/2_3.webp'),
    headline: 'Live Coaching',
    subtitle:
      'Work closely with coaches to help you manage your diabetes and improve your health.',
  },
  {
    id: 2,
    imageEllipse: require('../images/onBoardingSlideshow/3_ellipse.webp'),
    image1: require('../images/onBoardingSlideshow/3_1.webp'),
    image2: require('../images/onBoardingSlideshow/3_2.webp'),
    image3: require('../images/onBoardingSlideshow/3_3.webp'),
    headline: 'Resources',
    subtitle:
      'Access articles and videos to help you learn more about how you can manage your health.',
  },
  {
    id: 3,
    imageEllipse: require('../images/onBoardingSlideshow/4_ellipse.webp'),
    image1: require('../images/onBoardingSlideshow/4_1.webp'),
    image2: require('../images/onBoardingSlideshow/4_2.webp'),
    image3: require('../images/onBoardingSlideshow/4_3.webp'),
    headline: 'Bluetooth Sync',
    subtitle:
      'Sync with your device to track and analyze your daily readings in real time.',
  },
  {
    id: 4,
    imageEllipse: require('../images/onBoardingSlideshow/5_ellipse.webp'),
    image1: require('../images/onBoardingSlideshow/5_1.webp'),
    image2: require('../images/onBoardingSlideshow/5_2.webp'),
    image3: require('../images/onBoardingSlideshow/5_3.webp'),
    headline: 'Tech Support',
    subtitle: 'Get the support you need, when you need it.',
  },
  {
    id: 5,
    imageEllipse: require('../images/onBoardingSlideshow/6_ellipse.webp'),
    image1: require('../images/onBoardingSlideshow/6_1.webp'),
    image3: require('../images/onBoardingSlideshow/6_3.webp'),
    headline: 'Chat',
    subtitle:
      'Stay up to date, and connected with live messaging and video chat with your coach.',
  },
];

export default data;
